var exports = {
  "wrapper": "xaee3c4fa--ed22a8--wrapper",
  "icon-wrapper": "xaee3c4fa--ed22a8--icon-wrapper",
  "_published": "xaee3c4fa--ed22a8--_published",
  "_moderation": "xaee3c4fa--ed22a8--_moderation",
  "_draft": "xaee3c4fa--ed22a8--_draft",
  "_rejected": "xaee3c4fa--ed22a8--_rejected",
};

module.exports = exports;
